import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form, Offcanvas, Tooltip, OverlayTrigger, Button, Dropdown } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { getProductLIstAction, loadingToggleAction, modalToggleAction, createProductAction } from '../../../store/actions/ProductActions';
import Pagination from '../../constant/Pagination';
import { getProductCategoryList, getUnitList } from '../../../services/OtherService';
import { exportProductApi } from '../../../services/ProductService';
import TableLoaderEffect from '../../constant/TableLoader';
import { toast } from 'react-toastify';
import HelpTooltip from '../../constant/HelpToolTip';
import DebounceSearchInput from '../../constant/DebounceSearchInput';
import ExportModal from '../../constant/ExportModal';
const EmptyProduct = {
    name: '',
    price: '',
    ucs_code: '',
    min_threshold: '',
    max_threshold: '',
    unit: 'KG',
    unit_type: 'multi',
    category: '',
    description: '',
    sap_description: '',
    ved_category: 'Vital',
    lead_time: '',
    perishable_product: false
}

const Products = (props) => {

    const [params, setParams] = useState({
        page: 1,
        page_size: 10,
        query: "",
        status: "",
        stock_type: "",
        unit_type: "",
        perishability: "",
    });

    const filterHeader = {
        stock_type: "Stock Type",
        unit_type: "Unit Type",
        perishability: "Perishability",
        status: "Status"
    }

    const filterOptions = {
        stock_type: ['Under Stock', 'In Stock', 'Over Stock'],
        unit_type: ['Single Quantity', 'Multiple Quantities'],
        perishability: ['Perishable Material', 'Non-Perishable Material'],
        status: ['Active', 'Inactive'],
    };


    const dispatch = useDispatch()
    const [formValue, setFormValue] = useState(EmptyProduct)
    const [categoryList, setCategoryList] = useState([])
    const [unitList, setUnitList] = useState([])

    useEffect(() => {
        dispatch(loadingToggleAction(true))
        dispatch(getProductLIstAction(params))
    }, [props.stockUpdateKey])


    const toggleAddModal = (modal_type) => {
        if (modal_type === "Add") {
            if (props.openModal) {
                setFormValue(EmptyProduct)
                setCategoryList([])
                setUnitList([])
            } else {
                getProductCategoryList().then(resp => {
                    setCategoryList(resp.data.data)
                }).catch(error => {
                    console.log(error)
                })
                getUnitList().then(resp => {
                    setUnitList(resp.data.data)
                }).catch(error => {
                    console.log(error)
                })
            }
        }
        dispatch(modalToggleAction(modal_type))
    }

    const handleChangeAdd = (e) => {
        const { name, value } = e.target
        setFormValue({ ...formValue, [name]: value })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const requiredFieldValue = [formValue.name, formValue.ucs_code, formValue.unit, formValue.min_threshold]
        if (requiredFieldValue.some(itm => itm.length === 0)) {
            toast.error("Required all mandatory fields")
            return false
        } else {
            dispatch(createProductAction(formValue))
        }
    }

    const handlePagination = page => {
        dispatch(loadingToggleAction(true))
        const newPage = page.selected + 1
        const updatedParams = { ...params, page: newPage }
        setParams(updatedParams);
        dispatch(getProductLIstAction(updatedParams))
    }

    const handleSearchChange = (newQuery) => {
        const updatedParams = { ...params, query: newQuery, page: 1 }
        setParams(updatedParams);
        dispatch(getProductLIstAction(updatedParams))
    }

    const getFilterCount = () => {
        const keysToCheck = ['status', 'stock_type', 'unit_type', 'perishability'];
        return keysToCheck.filter((key) => params[key]).length;
    };

    const handleFilterChange = (type, value) => {
        const updatedParams = { ...params, page: 1, [type]: params[type] === value ? "" : value }
        setParams(updatedParams);
        dispatch(getProductLIstAction(updatedParams))
    };

    const handleClear = () => {
        const updatedParams = {
            ...params,
            page: 1,
            status: "",
            stock_type: "",
            unit_type: "",
            perishability: "",
        }
        setParams(updatedParams)
        dispatch(getProductLIstAction(updatedParams))
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center p-3">
                                    <h4 className="mb-0">Materials</h4>

                                    <div className='d-flex align-items-center flex-wrap gap-3'>
                                        <div>
                                            <Dropdown >
                                                <Dropdown.Toggle
                                                    as="div"
                                                    className="btn btn-outline-primary no-hover d-flex align-items-center gap-2 no-hover no-caret"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <span><i className="fa-solid fa-filter pe-2"></i> Filter</span>
                                                    {getFilterCount() > 0 ? (
                                                        <span className="badge badge-sm bg-info rounded-circle">
                                                            {getFilterCount()}
                                                        </span>
                                                    ) : <span className='ps-3'></span>}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu style={{ minWidth: 250 }}>
                                                    <div className="d-flex justify-content-between align-items-center p-2">
                                                        <h4 className='mb-0'>Filters</h4>
                                                        {getFilterCount() > 0 && (
                                                            <Button variant="outline-danger" size='sm' onClick={handleClear}>
                                                                Clear All
                                                            </Button>
                                                        )}
                                                    </div>
                                                    <hr className='m-0' />
                                                    <div className="p-3">
                                                        {Object.entries(filterOptions).map(([key, options]) => (
                                                            <div key={key} className="mb-2">
                                                                <strong className="text-capitalize">{filterHeader[key]}</strong>
                                                                <div className='px-2'>
                                                                    {options.map((option) => (
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            key={option}
                                                                            label={option}
                                                                            checked={params[key] === option}
                                                                            onChange={() => handleFilterChange(key, option)}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                        <div className='form-group'>
                                            <DebounceSearchInput handleSearchChange={handleSearchChange} />
                                        </div>
                                        {(props.role === "Admin" || props?.user_permission?.manage_material) &&
                                            <>
                                                <button className="btn btn-primary" data-bs-toggle="offcanvas"
                                                    onClick={() => toggleAddModal("Add")}
                                                ><i className="fa-solid fa-plus me-1"></i> Add Material</button>

                                                <div>
                                                    <ExportModal
                                                        exportApi={exportProductApi}
                                                        params={
                                                            {
                                                                query: params.query,
                                                                status: params.status,
                                                                stock_type: params.stock_type,
                                                                unit_type: params.unit_type,
                                                                perishability: params.perishability,
                                                            }
                                                        }
                                                        title="Export Materials"
                                                    />

                                                </div>
                                            </>
                                        }

                                    </div>
                                </div>

                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Material Name</th>
                                                    <th>UCS Code</th>
                                                    <th>Price</th>
                                                    <th>Quantity</th>
                                                    <th>Min Threshold</th>
                                                    <th>Max Threshold</th>
                                                    <th>Unit</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {props.isLoading ? <TableLoaderEffect colLength={7} /> : props.products.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <Link to={`/material/${item.id}`} className='text-primary fw-bold'>{item.name}</Link>
                                                        </td>
                                                        <td><span>{item.ucs_code}</span></td>
                                                        <td><span>{item.price}</span></td>
                                                        <td><span>{item.net_quantity}</span></td>
                                                        <td><span>{item.min_threshold}</span></td>
                                                        <td><span>{item.max_threshold}</span></td>
                                                        <td><span>{item.unit.name}</span></td>
                                                    </tr>
                                                ))}
                                            </tbody>

                                        </table>
                                        {props.isLoading ? <div style={{ height: '4rem' }}></div> : <Pagination
                                            currentPage={params.page}
                                            recordsPage={params.page_size}
                                            dataLength={props.totals}
                                            handlePagination={handlePagination}
                                        />
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* add product modal */}
            <Offcanvas show={props.openModal && props.modalType === "Add"} onHide={() => toggleAddModal("Add")} className="offcanvas-end customeoff" placement='end'>
                <div className="offcanvas-header">
                    <h5 className="modal-title" id="#gridSystemModal">Add Material</h5>
                    <button type="button" className="btn-close"
                        onClick={() => toggleAddModal("Add")}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="container-fluid">
                        <Form onSubmit={(e) => handleSubmit(e)}>
                            <div className="row">
                                <div className="col-xl-6">
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Material Name <span className="text-danger">*</span></label>
                                        <input type="text" autoFocus className="form-control" id="name" placeholder="Enter Name"
                                            value={formValue.name} name='name' onChange={handleChangeAdd} required />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="ucs_code" className="form-label">UCS Code <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" id="ucs_code" placeholder="Enter UCS code"
                                            value={formValue.ucs_code} name='ucs_code' onChange={handleChangeAdd} required />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Unit <span className="text-danger">*</span></label>
                                        <select className="default-select form-control" name='unit' value={formValue.unit} onChange={handleChangeAdd} required>
                                            <option value="">Select Unit</option>
                                            {unitList.map((item, index) => (
                                                <option value={item.value} key={index}>{item.label}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="min_threshold" className="form-label">Min Threshold <span className="text-danger">*</span></label>
                                        <input type="number" className="form-control" id="min_threshold" placeholder="Enter Min Threshold"
                                            value={formValue.min_threshold} name='min_threshold' onChange={handleChangeAdd} required />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="max_threshold" className="form-label">Max Threshold </label>
                                        <input type="number" className="form-control" id="max_threshold" placeholder="Enter Max Threshold"
                                            value={formValue.max_threshold} name='max_threshold' onChange={handleChangeAdd} />
                                    </div>

                                    <div className="mb-1">
                                        <label>Unit Item Type <UnitItemTypeTooltip /></label><br />
                                        <div className="form-check custom-checkbox mb-2 form-check-inline">
                                            <input type="radio" className="form-check-input"
                                                id="unit_type_multi" name="unit_type" checked={formValue.unit_type === "multi"} value={'multi'} onChange={handleChangeAdd} />
                                            <label className="form-check-label" htmlFor="unit_type_multi">Multiple Items</label>
                                        </div>

                                        <div className="form-check custom-checkbox mb-2 form-check-inline">
                                            <input type="radio" className="form-check-input"
                                                id="unit_type_single" name="unit_type" checked={formValue.unit_type === "single"} value={'single'} onChange={handleChangeAdd} />
                                            <label className="form-check-label" htmlFor="unit_type_single">Single Item</label>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label>Perishable Product <HelpTooltip text={"Products that have a limited shelf life."} /></label><br />
                                        <div className="form-check custom-checkbox mb-2 form-check-inline">
                                            <input type="radio"
                                                className="form-check-input"
                                                id="Perishable_YES" name="perishable_product"
                                                checked={formValue.perishable_product}
                                                onChange={() => setFormValue({ ...formValue, perishable_product: true })} />
                                            <label className="form-check-label" htmlFor="Perishable_YES">YES</label>
                                        </div>

                                        <div className="form-check custom-checkbox mb-2 form-check-inline">
                                            <input type="radio" className="form-check-input"
                                                id="Perishable_NO" name="perishable_product"
                                                checked={!formValue.perishable_product}
                                                value={false}
                                                onChange={() => setFormValue({ ...formValue, perishable_product: false })} />
                                            <label className="form-check-label" htmlFor="Perishable_NO">NO</label>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-xl-6">
                                    <div className="mb-3">
                                        <label htmlFor="price" className="form-label">Price </label>
                                        <input type="number" className="form-control" id="price" placeholder="Enter Price"
                                            value={formValue.price} name='price' onChange={handleChangeAdd} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">VED Category </label>
                                        <select className="default-select form-control" value={formValue.ved_category} name='ved_category' onChange={handleChangeAdd}>
                                            <option value="Vital">Vital</option>
                                            <option value="Essential">Essential</option>
                                            <option value="Desirable">Desirable</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="price" className="form-label">Lead Time (in Day)  </label>
                                        <input type="number" className="form-control" id="lead_time" placeholder="Enter Lead Time in day"
                                            value={formValue.lead_time} name='lead_time' onChange={handleChangeAdd} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Material Category </label>
                                        <select className="default-select form-control" name='category' value={formValue.category} onChange={handleChangeAdd}>
                                            <option value="">Select Category</option>
                                            {categoryList.map((item, index) => (
                                                <option value={item.value} key={index}>{item.label}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Description </label>
                                        <textarea style={{ minHeight: "30px" }} className="form-control" placeholder='Enter description' value={formValue.description} name='description' onChange={handleChangeAdd}></textarea>
                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label className="form-label">Description SAP</label>
                                        <textarea rows="2" className="form-control" placeholder='Enter description SAP' value={formValue.sap_description} name='sap_description' onChange={handleChangeAdd}></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <button type="submit" className="btn btn-primary me-1">Submit</button>
                                <button type="button" onClick={() => toggleAddModal("Add")} className="btn btn-danger light ms-1">Cancel</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </Offcanvas>

        </>
    );
};


function UnitItemTypeTooltip() {
    return (
        <OverlayTrigger
            placement={"bottom"}
            overlay={
                <Tooltip id={'tooltip-unit-type-add-material'}>
                    <div className='d-flex align-items-center justify-content-start flex-column'>
                        <span className='mt-3'><strong className='text-warning'>Multiple Items: </strong><br />Each stock entry may contain one or more quantities but shares a single barcode</span><br />
                        <span><strong className='text-warning'>Single Item: </strong><br />Each stock entry contains only one quantity with a unique barcode</span>
                    </div>
                </Tooltip>
            }
        >
            <span className="cursor-pointer text-primary ms-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                </svg>
            </span>
        </OverlayTrigger>
    );
}


const mapStateToProps = (state) => {
    return {
        products: state.products.products,
        totals: state.products.totals,
        selectedProduct: state.products.selectedProduct,
        isLoading: state.products.isLoading,
        openModal: state.products.isModalOpen,
        modalType: state.products.modalType,
        stockUpdateKey: state.auth.stockUpdateKey,
        user_permission: state.auth.user.user_permission,
        role: state.auth.user?.role


    };
};

export default connect(mapStateToProps)(Products);


